<template>

  <section>
    <v-container container--fluid grid-list-xl class="px-0">
      <v-row class="px-4">
        <v-col cols="12" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
          <h1 v-if="tab == 0" :class="{'text-little': $vuetify.breakpoint.smAndDown}">Runs</h1>
          <h1 v-else :class="{'text-little': $vuetify.breakpoint.smAndDown}">Runs Schedule</h1>
        </v-col>
      </v-row>
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="blue"
        grow
        slider-color="cyan accent-4"
      >
        <v-tab key="0">
          <v-icon class="mr-4">fas fa-truck-moving</v-icon>
          Runs
        </v-tab>
        <v-tab key="1">
          <v-icon class="mr-4">fas fa-table</v-icon>
          Runs Schedule
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" touchless>
        <v-tab-item :key="0">

            <v-row :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
            <v-col cols="12" sm="12" md="2">
              <v-text-field
                v-model="search"
                label="Search..."
                prepend-icon="fas fa-search"
                clearable
              >
              </v-text-field>
            </v-col>
            <v-col cols="4" md="1">
            </v-col>
            <v-col cols="6" md="1">
              <div style="display: flex; justify-content: center; align-items: center">
                <v-btn text @click="refresh" v-if="!loading">
                  <v-icon color="cyan darken-2">refresh</v-icon>
                </v-btn>
                <div v-if="loading" class="load-3">
                  <div class="line"></div>
                  <div class="line"></div>
                  <div class="line"></div>
                </div>
              </div>
            </v-col>
            <v-col cols="4" md="2">
            </v-col>
            <v-col cols="4" md="2">
              <v-autocomplete
                label="Choose a depot..."
                :items="renderedDepots"
                item-text="name"
                item-value="id"
                v-model="depot"
                return-object
              ></v-autocomplete>
            </v-col>
            <v-col cols="4" md="2">
              <v-dialog
                ref="dialogDate"
                v-model="dateDialog"
                :return-value.sync="date"
                close-on-content-click
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="date"
                    label="Date ..."
                    v-on="on"
                    class="pb-4"
                    readonly
                  >
                  </v-text-field>
                </template>
                <v-date-picker v-model="date" @input="$refs.dialogDate.save(date)">
                  <v-spacer></v-spacer>
                  <v-btn text color="blue darken-1" @click="dateDialog = false">Cancel</v-btn>
                  <v-btn text color="blue darken-1" @click="$refs.dialogDate.save(date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="4" md="2">
            </v-col>
          </v-row>
             <transition name="slide-x-transition">
              <v-progress-linear v-if="loading" :indeterminate="loading"></v-progress-linear>
             </transition>
            <v-data-table
            :search="search"
            :headers="headers"
            :items="renderedRuns"
            :items-per-page="12"

          >
            <template v-slot:item="props">
              <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}" @click="selectRun(props.item)">
                <td style="text-align: center" v-if="header.text !== 'Actions'" v-for="(header, index) in headers" :key="index">
                  <div v-if="header.text !=='Deliveries'">
                    {{props.item[header.value]}}</div>
                  <div v-else
                       :class="header.value === 'stop_count' ? (props.item.stop_count == props.item.deliveries_audit ? 'blue-text' : 'red-text') : ''"
                  >{{props.item[header.value]}}</div>
                </td>

                <td v-else class="text-center">
                  <v-tooltip top color="secondary" v-if="isAdmin">
                    <template v-slot:activator="{ on }">
                      <v-icon :disabled="props.item['status_text'] !== 'Pending'" color="blue" @click.stop="startPlanning(props.item.id)" v-on="on">
                        play_arrow
                      </v-icon>
                    </template>
                    <span>Start Planning</span>
                  </v-tooltip>
                  <v-tooltip top color="secondary" v-if="isAdmin || reportsPermission">
                    <template v-slot:activator="{ on }">
                      <v-icon color="blue" @click.stop="getDispatchReport(props.item.id)" v-on="on">
                        note
                      </v-icon>
                    </template>
                    <span>Dispatch Report</span>
                  </v-tooltip>
                  <v-tooltip top color="secondary" v-if="isAdmin">
                    <template v-slot:activator="{ on }">
                      <v-icon :disabled="props.item['status_text'] !== 'Pending'" color="red" @click.stop="startPlanningTo98(props.item.id)" v-on="on">
                        play_arrow
                      </v-icon>
                    </template>
                    <span>Start Planning for testing on 96</span>
                  </v-tooltip>
                  <v-tooltip top color="secondary" v-if="isAdmin">
                    <template v-slot:activator="{ on }">
                      <v-icon :disabled="props.item['status_text'] !== 'Pending'" color="green" @click.stop="rollback(props.item.id)" v-on="on">
                        sync
                      </v-icon>
                    </template>
                    <span>Roll back sorter</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
            </v-tab-item>

        <v-tab-item :key="1">
          <RunSchedule
          ></RunSchedule>
          <v-divider></v-divider>
        </v-tab-item>
      </v-tabs-items>

      <v-dialog v-model="rollbackDialog" width="600px">
        <v-card>
          <v-card-title class="justify-center">
            <h2>ALERT</h2>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="text-center">
            <v-container container--fluid>
              You are about to rollback this run. <br>
              This action cannot be undone, are you sure you want to proceed ?
            </v-container>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn text color="red" @click="rollbackDialog=false">No</v-btn>
            <v-btn text color="blue darken-1" @click="rollbackRun">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-container>

    <RunsStopsDialog
      :show-dialog="showDialog"
      :run-obj="runObj"
      :run-id="runId"
      @close="closeDialog"
    ></RunsStopsDialog>


  </section>
</template>

<script>
import axios from 'axios';
import RunsStopsDialog from "./Runs/RunsDialog";
import RunSchedule from "./Runs/RunSchedule";
import moment from "moment";

export default {
  name: "Runs",
  components: {
    RunsStopsDialog,
    RunSchedule
  },
  data() {
    return {
      tab: 0,
      search: '',
      loading: false,
      reload:false,
      headers: [
        {text: 'Id', value: 'id', align: 'center', sortable: true},
        {text: 'Depot', value: 'depot_name', align: 'center', sortable: true},
        {text: 'Date', value: 'date', align: 'center', sortable: true},
        {text: 'Type', value: 'type', align: 'center', sortable: true},
        {text: 'Sort Code', value: 'sort_code', align: 'center', sortable: true},
        {text: 'Status', value: 'status_text', align: 'center', sortable: true},
        {text: 'Push On', value: 'last_push', align: 'center', sortable: true},
        {text: 'Push By', value: 'pushed_by', align: 'center', sortable: true},
        {text: 'Push Deliveries', value: 'push_deliveries', align: 'center', sortable: true},
        {text: 'Deliveries', value: 'stop_count', align: 'center', sortable: true},
        {text: 'Delivery Changes', value: 'delivery_changes', align: 'center', sortable: true},
        {text: 'Boxes', value: 'tag_count', align: 'center', sortable: true},
        {text: 'Actions', value: 'actions', align: 'center', sortable: false}
      ],

      valid:false,
      showDialog:false,
      depot: null,
      dateDialog:false,
      date: null,
      searchStop:'',
      stops:'',
      runObj:null,
      runId:null,
      rollbackDialog: false,

    }
  },
  mounted: function () {
    this.date = moment().format('YYYY-MM-DD');
  },
  methods: {
    closeDialog(){
      this.runObj = Object.assign({}, this.default);
      this.runId = null;
      this.showDialog = false;
      this.reload = !this.reload;
    },
    rollback(item){
      this.rollbackDialog = true;
      this.runId = item;
    },
    rollbackRun(){
      if(this.runId){
        axios.get(process.env.API_URL + '/runs/' + this.runId+ '/sorterrollback')
          .then((response) => {
            this.$store.commit('displaySnackbar', "rollback successfully");
            this. refresh();
          })
          .catch((error) => {
            this.$store.commit('displaySnackbar', "Error while rollback");
          });
      }
      this.rollbackDialog = false;
    },
    startPlanning(item_id){
      if (confirm("Are you sure you want to start planning for staging run " + item_id + "?")) {
        if(item_id){
          axios.get(process.env.API_URL + '/runs/' + item_id+ '/startplanning')
            .then((response) => {
              this.$store.dispatch('displayJobDialog', response.data);
              this. refresh();
            })
            .catch((error) => {
              this.$store.commit('displaySnackbar', "Error while start planning");
            });
        }
      }
    },
    startPlanningTo98(item_id){
      if (confirm("Are you sure you want to start planning for staging run " + item_id + "?")) {
        if(item_id){
          axios.get(process.env.API_URL + '/runs/' + item_id+ '/startplanningtesting')
            .then((response) => {
              this.$store.dispatch('displayJobDialog', response.data);
              this. refresh();
            })
            .catch((error) => {
              this.$store.commit('displaySnackbar', "Error while start planning");
            });
        }
      }
    },
    getDispatchReport(item_id) {
      window.open(process.env.API_URL + '/runs/' + item_id + '/dispatchreport?key=' + encodeURI(this.$store.state.auth.key), '_blank')
    },
    selectRun(item){
      this.runObj = Object.assign({}, item);
      this.runId = this.runObj.id;
      this.showDialog = true;
    },
    refresh() {
      this.reload = !this.reload;
    },
    getRunStops(run){
      this.loading = true;
      return axios.get(process.env.API_URL + '/runs/' + run.id + '/stops')
        .then((response) => {
          if (response.status === 200) {
            this.loading = false;
            this.stops = response.data;
            return response.data;
          } else {
            this.loading = false;
            return [];
          }
        })
        .catch((error) => {
          this.loading = false;
          return [];
        });
    }
  },
  computed: {
    renderedRuns() {
      if (this.runs === null || this.runs === undefined) {
        return [];
      } else {
        return this.runs;

      }
    },
    renderedDepots(){
      if (this.depots === null || this.depots === undefined) {
        return [];
      } else {
        return this.depots;
      }
    },
    isAdmin() {
      return this.$store.getters['auth/hasPermission']('delivery_admin');
    },
    reportsPermission() {
      return this.depot && this.$store.getters['auth/hasPermissionRegionId']('delivery_reports', this.depot.region_id);
    }
  },
  asyncComputed: {
    async runs() {
      if (this.reload || !this.reload) {
        if (this.date && this.depot) {
          this.loading = true;
          return await axios.get(process.env.API_URL + '/runs?' + 'date=' + this.date + '&depot_id=' + this.depot.id)
            .then((response) => {
              if (response.status === 200) {
                this.loading = false;
                return response.data;
              } else {
                this.loading = false;
                return [];
              }
            })
            .catch((error) => {
              this.loading = false;
              return [];
            });
        }
      }
    },
    async depots() {
      return await axios.get(process.env.API_URL +'/depots')
        .then((response) => {
          if (response.status === 200) {
            return response.data.sort((a, b) => (a.name > b.name) ? 1 : -1);
          } else {
            return [];
          }
        })
        .catch((error) => {
          return [];
        });
    },
  }

}
</script>

<style scoped>

>>>.v-tabs-bar.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows):not(.v-slide-group--has-affixes) .v-slide-group__prev {
  display: none!important;
}

.line {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 15px;
  background-color: #6754a8;
}

@keyframes loadingC {
0 {transform: translate(0,0);}
50% {transform: translate(0,15px);}
100% {transform: translate(0,0);}
}

.load-3 .line:nth-last-child(1) {animation: loadingC .6s .1s linear infinite;}
.load-3 .line:nth-last-child(2) {animation: loadingC .6s .2s linear infinite;}
.load-3 .line:nth-last-child(3) {animation: loadingC .6s .3s linear infinite;}

.blue-text {
  color: blue;
}

.red-text {
  color: red;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Runs.vue